export class MailDeliveryToDoorModel {
  public postNumber = '';
  public cityName = '';

  public address = '';
  public userName = '';
  public deliveryType = '';
  deliveryLatitude: number = null;
  deliveryLongitude: number = null;

  constructor(info?: Partial<MailDeliveryToDoorModel>) {
    if (info) {
      Object.assign(this, info);
    }
  }
}
